import React from 'react'
import { Box, Button, Card, CardContent, Grid, Typography } from '@material-ui/core'

import { Audit } from '../../api/models'

interface AuditCardProps {
  item: Audit
}

export const AuditCard = (props: AuditCardProps) => {
  const { item } = props
  const Icon = item.icon

  const event: CustomEvent<any> = new CustomEvent('skuitCommand', { detail: { command: 'audit' } })
  return (
    <Card>
      <CardContent>
        <Typography>
          <Icon /> {item.typeDisplay}
        </Typography>
        <Grid container spacing={10}>
          <Grid item container>
            <Grid item container spacing={6} xs={12}>
              <Grid item>
                <Box fontWeight="bold">SquID:</Box>
              </Grid>
              <Grid item>{item.guid}</Grid>
            </Grid>
            <Grid item container spacing={6} xs={12}>
              <Grid item>
                <Box fontWeight="bold">Name:</Box>
              </Grid>
              <Grid item>{item.name}</Grid>
            </Grid>
          </Grid>
          <Grid item container>
            <Grid item spacing={6} xs={12}>
              <Typography variant="h5">
                Quick Actions
              </Typography>
            </Grid>
            {item.status === Audit.Status.inProgress && (
              <Grid item spacing={8} xs={12}>
                <Button variant="outlined" color="primary" onClick={() => window.dispatchEvent(event)}>
                  Start Audit
                </Button>
              </Grid>
            )}
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  )
}
